import Flights from './Flights';

export default Flights;
